import React from 'react';
import MyText from './MyText';
import {theme} from '../utils/theme';

export default function RadioButtonGroup(props){

    const [selectedKey, setSelectedKey] = React.useState(props.value ? props.value : '');
    
    const handleOptionChange = (x) => {
        setSelectedKey(x);
        props.onChange && props.onChange(x);
    }

    const buildOptions = () => {
        return props.options.map((option, index) => {
            return(
                <div key={props.groupName+"_"+index} style={styles.option}>
                    <div style={{...styles.radio, backgroundColor: selectedKey === option.key ? theme.primary : 'white'}} 
                        onClick={()=>handleOptionChange(option.key)}/>
                    <MyText style={styles.optionLabel}>{option.label}</MyText>
                </div>
            );
        });
    }
    
    return(
        <div style={styles.container}>
            <MyText style={styles.groupName}>{props.groupName}</MyText>
            <div style={styles.optionContainer}>
                {buildOptions()}
            </div>
        </div>
    );
};
const styles = {
    container:{
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
    },
    groupName:{
        fontSize: '1.2rem',
    },
    optionContainer:{
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        marginLeft: 10,
    },
    option:{
        display: 'flex',
        flexDirection: 'row',
        gap: 20,
        // alignItems: 'center',
    },
    radio:{
        width: 20,
        height: 20,
        boxShadow: '0px 4px 4px 0px #00000040',
        border: 'none',
        borderRadius: '50%',
        // WebkitAppearance: 'initial',
        backgroundColor: 'white',
    },
    optionLabel:{
        fontSize: '1rem',
        maxWidth: '80%',
    }
}